<template>
  <ul
    class="item-list"
    :ref="this.id"
    :style="this.animationClass"
  >
    <li
      class="item"
      v-for="(item, index) in this.items"
      :key="index"
      @click="goToAlarm(item)"
    >
      <p><strong>{{item.alarmName}}</strong></p>
      <p class="item__installation">{{item.companyName}} - {{item.installationName}}</p>
      <p>
        {{$t('dashboard.acted-on')}} {{
          item.dateAndTime | dateTimeFilter({ format })
        }}
        {{$t('general.and')}} {{recognizedText(item.recognizedAlarm)}}
      </p>
    </li>
  </ul>
</template>

<script>
import AlarmsReportMixin from '@/domain/mixins/generalPanel/reports/alarmsReportMixin';
import { formats } from '@/constants/localizer';

export default {
  name: 'AlarmBreakingNewsItem',
  mixins: [AlarmsReportMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    pause: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    animationClass() {
      const frame = this.animation ? this.frameRate : 0;
      return {
        left: `${this.xPosition}px`,
        transition: `left ${frame}ms linear`,
      };
    },
  },
  data: () => ({
    format: formats.DATETIME_SHORT,
    xPosition: 0,
    frameRate: 1000,
    speed: 100,
    animation: null,
    listReference: null,
    listSize: 0,
    separationSize: 400,
    isInitialized: false,
    sizeToShowNextItem: 0,
    showedNextItem: false,
  }),
  created() {
    this.xPosition = window.innerWidth;
    this.adjustWindowSize();
  },
  mounted() {
    this.listReference = this.$refs[this.id];
    this.listSize = this.listReference.offsetWidth;
    this.startAnimation();
    window.addEventListener('onresize', this.adjustWindowSize, false);
  },
  methods: {
    adjustWindowSize() {
      this.sizeToShowNextItem = window.innerWidth / 2;
    },
    goToAlarm(alarmData) {
      const filter = {
        assetsIds: [alarmData.assetId],
      };
      this.openAlarmAndWarning(filter);
    },
    pauseAnimation() {
      clearInterval(this.animation);
      const computedStyle = this.getComputedStyle();
      const currentPosition = computedStyle.getPropertyValue('left');
      const [position] = currentPosition.split('px');
      this.xPosition = position;
    },
    getComputedStyle() {
      return window.getComputedStyle(this.listReference);
    },
    startAnimation() {
      if (this.animation) {
        this.pauseAnimation();
      }

      this.animationFunction();
      this.animation = setInterval(this.animationFunction, this.frameRate);
    },
    animationFunction() {
      this.xPosition -= this.speed;

      const amountDislocated = this.listSize + this.xPosition;
      const canShowNextItem = amountDislocated <= this.sizeToShowNextItem;
      if (!this.showedNextItem && canShowNextItem) {
        this.showedNextItem = true;
        this.$emit('next-item');
      }

      const finishedAnimation = this.listSize + this.xPosition <= 0;
      if (finishedAnimation) {
        this.$emit('finished-item', this.id);
        clearInterval(this.animation);
      }
    },
    recognizedText(recognizedAlarm) {
      return recognizedAlarm
        ? this.$t('dashboard.recognized')
        : this.$t('dashboard.not-recognized');
    },
  },
  watch: {
    pause(newValue) {
      if (newValue) {
        this.pauseAnimation();
        return;
      }

      this.startAnimation();
    },
  },
};
</script>
<style scoped lang="sass">
@import "src/styles/defaults/variables"
.item
  display: flex
  align-items: center
  margin-left: 1.45rem
  white-space: nowrap
  text-transform: uppercase
  width: 100%
  color: $color-black-87-no-opacity
  & p
    margin-bottom: 0
  &:not(:first-child):before
    content: '/'
    font-weight: bold
    margin-right: 1.45rem
  &-list
    display: flex
    align-items: center
    list-style: none
    position: absolute
    margin: 0
    height: 100%

  &:hover
    cursor: pointer
    color: var(--color-link)
  & p:not(:last-child)
    margin-right: 0.715rem
  &__installation
    color: var(--color-link)
</style>
